import * as React from "react";
const SvgNotes = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 21 22",
	width: "1em",
	height: "1em",
	...props
}, /* @__PURE__ */ React.createElement("defs", null), /* @__PURE__ */ React.createElement("g", {
	id: "notes_svg__Layer_2",
	"data-name": "Layer 2"
}, /* @__PURE__ */ React.createElement("g", {
	id: "notes_svg__Layer_1-2",
	"data-name": "Layer 1"
}, /* @__PURE__ */ React.createElement("path", {
	d: "M19 0H2a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2m0 20H2V2h17Z",
	style: { fill: "currentColor" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "M6.1 8h8.8A1.05 1.05 0 0 0 16 7a1.05 1.05 0 0 0-1.1-1H6.1A1.05 1.05 0 0 0 5 7a1.05 1.05 0 0 0 1.1 1M6.1 12h8.8a1 1 0 1 0 0-2H6.1a1 1 0 1 0 0 2M6 16h4a1 1 0 0 0 0-2H6a1 1 0 0 0 0 2",
	style: { fill: "currentColor" }
}))));
export default SvgNotes;
